document.querySelectorAll("[data-readmore]").forEach((block) => {

    if (block.dataset.readmoreInit) return
    block.dataset.readmoreInit = "true"

    const btn = block.querySelector(".home-seo-text__toggle")
    if (!btn) return

    btn.addEventListener("click", () => {

        const open = block.classList.toggle("is-open")

        btn.textContent = open ? "Réduire" : "Lire la suite"
        btn.setAttribute("aria-expanded", open)
    })
})